module.exports = __webpack_public_path__ + "img/shield.7fba7781.svg";